module.exports = __webpack_public_path__ + "img/invoice.7544de30.jpg";